module.exports = __webpack_public_path__ + "6f1d0fa723cf2444ec00818a17a02c43.svg";